import { PageTopPanel } from '../../../../../layout/shared-components/page-top-panel/PageTopPanel';
import { SearchWrapper } from '../../../../../layout/shared-components/SearchWrapper';

export const ListHeader = () => (
  <PageTopPanel title={'Enrollments'}>
    <SearchWrapper placeholder={'Search by course, author...'} isPage />
  </PageTopPanel>
);
